import { Component } from '@angular/core';

@Component({
  selector: 'app-cards8-examples-54',
  templateUrl: './cards8-examples-54.component.html'
})
export class Cards8Examples54Component {}
